import { Pipe, PipeTransform } from '@angular/core';
import i18next from 'i18next';

type PipeOptions = Record<string, unknown> & { returnObjects?: false };

@Pipe({
    name: 'i18next',
    standalone: true,
    pure: false
})
export class KokosI18NextPipe implements PipeTransform {
    transform(key: string | null | undefined, options?: PipeOptions): string {
        if (!key) return '';

        const opts: PipeOptions = { returnObjects: false, ...options };
        const res: unknown = i18next.t(key, opts as any);

        if (typeof res === 'string') return res;

        if (Array.isArray(res)) return res.join('');

        if (res == null) return '';

        return (res as { toString(): string }).toString();
    }
}





